import React from "react";
import RecentActivities from "../../../component/home/recent-activity";
import DashboardButtons from "../../../component/home/dashboard-actions";

const ListView = (props) => {
  return (
    <div className="space-y-2">
      <DashboardButtons />
      <RecentActivities
        cssClass="xl:block"
        activities={props.activities}
        // setActivities={props.setActivities}
        updateTable={props.updateTable}
        setUpdateTable={props.setUpdateTable}
        loader={props.loader}
        company_id={props.company_id}
        email={props.email}
        sortField={props.sortField}
        setSortField={props.setSortField}
        sortOrder={props.sortOrder}
        setSortOrder={props.setSortOrder}
        onPageChange={props.onPageChange}
        setDebouncedSearchText={props.setDebouncedSearchText}
      />
    </div>
  );
};

export default ListView;
